import type { PropsWithChildren, ReactNode } from "react";

import { AuthContext } from "./AuthContext";

/**
 * Auth provider for local development that bypasses MSAL authentication.
 * The Vite proxy injects the Authorization header server-side, so no client-side token is needed.
 *
 * @param {PropsWithChildren} props - The properties for the provider.
 * @returns {ReactNode} LocalAuthProvider component that provides a no-op authentication context.
 */
export const LocalAuthProvider = ({
    children,
}: PropsWithChildren): ReactNode => (
    <AuthContext
        value={{
            token: "local",
            logout: () => {},
            refreshToken: async () => {},
            isTokenExpired: () => false,
            isAuthenticated: true,
        }}
    >
        {children}
    </AuthContext>
);
